export function formatRegimeLabel(prefix, label) {
    return prefix + (label ?? "Regime")
}
